/* ============
 * Dashboard
 * ============
 *
 * This is the dashboard page.
 */

import accountService from './../../services/account';
import organizationSettingsTransformer from './../../transformers/organizationSettings';
import organizationSettingsService from './../../services/organizationSettings';
import { mapGetters, mapMutations } from 'vuex';
import billService from './../../services/bill';
import Forms from './../../utils/forms/forms';
import moment from 'moment';
import DateMixin from './../../mixins/date';
import store from "./../../store";
import Vue from "vue";

export default {
  data() {
    return {
       form: new Forms({
        billsDateRange: {
          value: [moment().subtract(1, 'months'), moment()],
          type: 'dateRange',
        },
        description: {
          value: '',
          type: 'textarea',
        },
      }),
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      account: 'account',
      providerList: 'setDownloadProviderList',
      settings: 'organizationSettings',
    }),
  },

  mounted() {
    this.getResources();
  },

  watch:{
    
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    /**
     * Fetch the component's required resources.
     */
    getResources() {
      var requests = [];
      if (Object.keys(this.settings).length === 0) {
        requests.push(organizationSettingsService.show());
      }
      this.loading = true;
      Promise.all(requests).then(() => {
        this.loading = false;
      });
    },

    store(){
      this.loading = false;
      this.form.loading = true;
      let me = this;
     /* console.log( this.form.data().billsDateRange[0]);
      return;
      const client = shippingTransformer.send(
        Object.assign({},)
      );*/
      
      const params = {};
      
      if(this.settings.accountingProvider) {
        if (this.form.data().billsDateRange[0] &&  this.form.data().billsDateRange[1]) {
          params.token = localStorage.getItem('id_token');
          params.date_start = moment(this.form.data().billsDateRange[0]).format('YYYY-MM-DD');
          params.date_stop = moment(this.form.data().billsDateRange[1]).format('YYYY-MM-DD');
          params.provider = this.settings.accountingProvider.slug;
          params.description =this.form.data().description;

        }

        console.log(params)

        
        this.selectedProvider = true;
        return new Promise((resolve, reject) => {
          Vue.$http.post('export-create-record', params).then(() => {
            billService.archiveReport().then(()=>{
              me.loading = false;
              me.form.loading = false;
              me.$message({
                    showClose: true,
                    message: me.$t('static.bills.exportBill.confirmSuccess'),
                    customClass: 'success',
                  });
              me.closeModal();
            });
            
          }).catch(() => {
            this.$message({
                  showClose: true,
                    message: this.$t('static.bills.exportBill.error'),
                    customClass: 'error',
            });
          });;
        })
      }
      else {
        this.$message({
                showClose: true,
                message: this.$t('static.bills.exportBill.providerNotSet'),
                customClass: 'error',
        });
      }
    },
    /*
    * Closes the modal
    */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },
  components: {
    VForm: require('./../../components/form/form.vue'),
    VMessage: require('./../../components/form/message/message.vue'),
    VDateRange: require('./../../components/form/dateRange/dateRange.vue'),
  },
  mixins: [
    DateMixin,
  ],
};



// WEBPACK FOOTER //
// ./src/app/components/ExportHistory/ExportHistory.js